<template>
  <div class="pagination">
    <el-pagination
      background
      layout="prev, pager, next"
      :page-size="pagInaS.pageSize"
      :total="total"
      :current-page="pagInaS.pageNum"
      hide-on-single-page
      @current-change="handleCurrentChange"
      @prev-click="handlePrevClick"
      @next-click="handleNextClick"
    />
  </div>
</template>

<script>
export default {
  name: "pagination",
  props: {
    total: "",
    pagInaS: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    // 切换页面
    handleCurrentChange(page) {
      this.$emit("currentChanged", page);
    },
    // 上一页
    handlePrevClick(page) {
      this.$emit("prevClicked", page);
    },
    // 下一页
    handleNextClick(page) {
      this.$emit("nextClicked", page);
    },
  },
};
</script>

<style lang="scss" scoped>
.pagination {
  width: 100%;
  margin: 0px 0 60px;
  @include crosswise(flex-end);

  ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: $menu-active-color;
  }
}
</style>
